import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.allowPointerEvents();
  }

  get checkboxes() {
    return new Array(...this.element.querySelectorAll("input[type=checkbox]"));
  }

  get selectedCheckboxes() {
    return this.checkboxes.filter((c) => c.checked);
  }

  get items() {
    return new Array(...this.element.querySelectorAll(".accordion__list-item"));
  }

  allowPointerEvents() {
    this.items.forEach(function (item) {
      item.removeAttribute("style");
    });
  }
}
